import {route} from '@/router/route-utils'

const prefix = '/admin/societies';

const routes = [

    route(
        prefix, 'admin.societies.list', {
            components : {
                main: () => import('./views/AdminSocietiesListView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Societies',
            breadcrumb: [
                {text: 'Societies', active: true},
            ],
        }
    ),

];

export default routes
